import {
   FavoriteMedicineDeleteCommand,
   PatientContinuouslyUsedMedicineDeleteCommand,
   PatientMedicineQuery,
} from '@dreryk/egabinet-prescription-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';
import { assertUnreachable } from '@dreryk/react-common';

import { MedicineReplacementSource } from '../medicineReplacement.types';

type WithdrawnMedicineRemoveActionInterceptorProps = {
   readonly children: JSX.Element;
   readonly medicineId: number;
   readonly source: MedicineReplacementSource;
};

export const WithdrawnMedicineRemoveActionInterceptor = (
   props: WithdrawnMedicineRemoveActionInterceptorProps
): JSX.Element => {
   const { executeAsync: removeWithdrawnMedicine } = useCqrsCommand<void, void>(
      () => {
         switch (props.source) {
            case 'favorite': {
               const command = new FavoriteMedicineDeleteCommand();
               command.medicineId = props.medicineId;
               return command;
            }
            case 'continuouslyUsedMedicine': {
               const command = new PatientContinuouslyUsedMedicineDeleteCommand();
               command.patientContinuouslyUsedMedicineId = props.medicineId;
               return command;
            }
            default:
               return assertUnreachable(props.source);
         }
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(PatientMedicineQuery);
         },
      }
   );

   return <ActionEventInterceptor action={removeWithdrawnMedicine}>{props.children}</ActionEventInterceptor>;
};
